// /opt/isp_erp/frontend/src/components/ONUStatusButton.jsx

import React, { useState } from 'react';
import axios from '../api/axios';

export default function ONUStatusButton({ onuId, currentStatus, onStatusChange }) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(currentStatus);

  const handleSuspend = async () => {
    if (!window.confirm('¿Suspender servicio? El cliente perderá conexión a internet.')) return;
    
    setLoading(true);
    try {
      await axios.post(`/olts/onus/${onuId}/suspend`, {}, {
        timeout: 60000  // ⏱️ 60 segundos de timeout
      });
      setStatus('suspended');
      onStatusChange?.('suspended');
      alert('✅ Servicio suspendido correctamente')

    } catch (error) {
      console.error('Error suspendiendo:', error);   

      // Mensaje más amigable para timeout
      if (error.code === 'ECONNABORTED') {

        alert('⚠️ La operación está tomando más tiempo del esperado. Verifica el estado del cliente en unos momentos.');

      } else {
        alert(error.response?.data?.detail || 'Error al suspender el servicio');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async () => {
    if (!window.confirm('¿Activar servicio? El cliente recuperará la conexión.')) return;
    
    setLoading(true);
    try {
      await axios.post(`/olts/onus/${onuId}/activate`, {}, {
        timeout: 60000
      });
      setStatus('active');
      onStatusChange?.('active');
      alert('✅ Servicio activado correctamente');
    } catch (error) {
      console.error('Error activando:', error);
      if (error.code === 'ECONNABORTED') {
        alert('⚠️ La operación está tomando más tiempo del esperado. Verifica el estado del cliente en unos momentos.');
      } else {
        alert(error.response?.data?.detail || 'Error al activar el servicio');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      {/* Indicador de estado */}
      <div className="flex items-center gap-2">
        <div className={`w-2.5 h-2.5 rounded-full ${
          status === 'active' ? 'bg-green-500 animate-pulse' : 'bg-red-500'
        }`} />
        <span className="text-xs font-medium">
          {status === 'active' ? 'Activo' : 'Suspendido'}
        </span>
      </div>

      {/* Botones de acción */}
      <div className="flex gap-2">
        {status === 'active' ? (
          <button
            onClick={handleSuspend}
            disabled={loading}
            className="flex items-center gap-1 bg-yellow-500 text-white px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-yellow-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
          >
            {loading ? (
              <>
                <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Procesando...</span>
              </>
            ) : (
              <>
                <span className="text-sm">⏸️</span>
                <span>Suspender</span>
              </>
            )}
          </button>
        ) : (
          <button
            onClick={handleActivate}
            disabled={loading}
            className="flex items-center gap-1 bg-green-500 text-white px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
          >
            {loading ? (
              <>
                <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Procesando...</span>
              </>
            ) : (
              <>
                <span className="text-sm">▶️</span>
                <span>Activar</span>
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
}
